import React, { useEffect, useState } from 'react'
import ContentHeader from '../../../../Components/Layout/ContentHeader'
import LayoutTable from '../../../../Components/Global/LayoutTable'
import { useQuery } from '@apollo/client'
import {
  ALL_MODULES,
  DELETE_MODULE,
  EXPORT_MODULES,
} from '../../../../graphql/Catalog/Modules/modules'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'

const extraRef = {
  query: ALL_MODULES,
  variables: {
    limit: null,
    offset: null,
  },
}

export const Modules = () => {
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
  })
  const [total, setTotal] = useState(0)
  const { loading, error, data } = useQuery(ALL_MODULES, {
    variables: {
      searchQuery: pagePagination.searchQuery,
      limit: pagePagination.limit,
      offset: pagePagination.offset,
    },
  })
  const [dataToTable, setDataToTable] = useState([])
  useEffect(() => {
    if (!loading) {
      if (error)
        toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      let list = []
      data.getAllModules.rows.map((item) => {
        return list.push({
          id: item.id,
          'Módulo nombre': item.name,
          Etiqueta: item.front_label,
          Enlace: item.relative_link,
          Icono: <i className={`fas fa-${item.icon}`}></i>,
          Submodulos: item.submodules.length,
        })
      })
      setDataToTable(list)
      setTotal(data.getAllModules.count)
    }
  }, [loading, error, data])
  return (
    <>
      <ContentHeader
        title="Gestión de módulos"
        breadcrumb="Módulos"
        windowTitle="Módulos"
      />
      <LayoutTable
        data={dataToTable}
        title="Lista de módulos"
        gql={DELETE_MODULE}
        requery={ALL_MODULES}
        extraRefetchDelete={extraRef}
        exportQuery={EXPORT_MODULES}
        totalCount={total}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        loadingData={loading}
        FilterBarPlaceholder="Buscar por nombre, link o etiqueta"
        hideDetails
      />
    </>
  )
}

export default Modules
